import React from 'react';
import { Repeat } from 'lucide-react';
import { useTranslation } from '../lib/i18n';

const HabitTracker = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <header>
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">{t('nav.habits')}</h2>
        <p className="text-sm sm:text-base text-gray-500">{t('navDesc.habits')}</p>
      </header>

      <div className="card text-center py-16">
        <Repeat size={48} className="mx-auto text-gray-300 mb-4" />
        <p className="text-gray-500">{t('placeholder.comingSoon')}</p>
      </div>
    </div>
  );
};

export default HabitTracker;
